{
  "name": "@ipreo/workbench",
  "version": "21.2.5",
  "main": "lib/bundles/ipreo-workbench.umd.js",
  "types": "lib/index.d.ts",
  "peerDependencies": {
    "@angular/common": "21.x",
    "@angular/core": "21.x",
    "@angular/router": "21.x",
    "@ipreo/common-draggable-layout": "0.1.11",
    "@ipreo/ngx-sprinkles": "21.x",
    "@ng-dynamic-forms/core": "12.x",
    "@ng-dynamic-forms/ui-basic": "12.x",
    "@ngrx/effects": "21.x",
    "@ngrx/store": "21.x",
    "ang-jsoneditor": "^1.6.2",
    "jsoneditor": "^5.24.3",
    "lodash": "4.x",
    "ngrx-store-localstorage": "21.x",
    "rxjs": "7.x",
    "sockjs-client": "^1.1.5"
  },
  "dependencies": {
    "tslib": "2.x"
  },
  "nmp": {
    "jsBundle": "./bundles-nmp/workbench.min.js",
    "jsBundleType": "umd",
    "private": false,
    "externalDependencies": {
      "lodash": "4.18.0"
    },
    "platforms": {
      "angular": {
        "moduleName": "WorkbenchModule",
        "componentName": "WorkbenchComponent"
      }
    }
  }
}